wp.customize.bind('ready', function () {
    wp.customize('osf_background_video_type', function (setting) {
        let visibility = function(){
            let arr = {
                osf_background_video_url: {
                    value: 'url',
                    equal: '='
                },
                osf_background_video_media: {
                    value: 'media',
                    equal: '='
                },
            };
            let value = '' + setting.get();
            for(let id in arr){
                $('#customize-control-' + id).hide();
                if(arr[id].equal === '!='){
                    if(arr[id].value !== value){
                        $('#customize-control-' + id).show();
                    }
                }else{
                   if(arr[id].value === value){
                        $('#customize-control-' + id).show();
                    }             
                }
            }
        }
        visibility();
        setting.bind(visibility);
    });
    wp.customize('osf_colors_buttons_enable_custom', function (setting) {
        let visibility = function(){
            let arr = {
                osf_colors_title_buttons_primary: {
                    value: 'true',
                    equal: '='
                },
                osf_colors_buttons_primary_bg: {
                    value: 'true',
                    equal: '='
                },
                osf_colors_buttons_primary_border: {
                    value: 'true',
                    equal: '='
                },
                osf_colors_buttons_primary_color: {
                    value: 'true',
                    equal: '='
                },
                osf_colors_buttons_primary_color_outline: {
                    value: 'true',
                    equal: '='
                },
                osf_colors_title_buttons_secondary: {
                    value: 'true',
                    equal: '='
                },
                osf_colors_buttons_secondary_bg: {
                    value: 'true',
                    equal: '='
                },
                osf_colors_buttons_secondary_border: {
                    value: 'true',
                    equal: '='
                },
                osf_colors_buttons_secondary_color: {
                    value: 'true',
                    equal: '='
                },
                osf_colors_buttons_secondary_color_outline: {
                    value: 'true',
                    equal: '='
                },
                osf_colors_title_buttons_primary_hover: {
                    value: 'true',
                    equal: '='
                },
                osf_colors_buttons_primary_hover_bg: {
                    value: 'true',
                    equal: '='
                },
                osf_colors_buttons_primary_hover_border: {
                    value: 'true',
                    equal: '='
                },
                osf_colors_buttons_primary_hover_color: {
                    value: 'true',
                    equal: '='
                },
                osf_colors_title_buttons_secondary_hover: {
                    value: 'true',
                    equal: '='
                },
                osf_colors_buttons_secondary_hover_bg: {
                    value: 'true',
                    equal: '='
                },
                osf_colors_buttons_secondary_hover_border: {
                    value: 'true',
                    equal: '='
                },
                osf_colors_buttons_secondary_hover_color: {
                    value: 'true',
                    equal: '='
                },
            };
            let value = '' + setting.get();
            for(let id in arr){
                $('#customize-control-' + id).hide();
                if(arr[id].equal === '!='){
                    if(arr[id].value !== value){
                        $('#customize-control-' + id).show();
                    }
                }else{
                   if(arr[id].value === value){
                        $('#customize-control-' + id).show();
                    }             
                }
            }
        }
        visibility();
        setting.bind(visibility);
    });
    wp.customize('osf_layout_general_layout_mode', function (setting) {
        let visibility = function(){
            let arr = {
                osf_layout_general_layout_boxed_width: {
                    value: 'boxed',
                    equal: '='
                },
                osf_layout_general_layout_boxed_offset: {
                    value: 'boxed',
                    equal: '='
                },
            };
            let value = '' + setting.get();
            for(let id in arr){
                $('#customize-control-' + id).hide();
                if(arr[id].equal === '!='){
                    if(arr[id].value !== value){
                        $('#customize-control-' + id).show();
                    }
                }else{
                   if(arr[id].value === value){
                        $('#customize-control-' + id).show();
                    }             
                }
            }
        }
        visibility();
        setting.bind(visibility);
    });
    wp.customize('osf_layout_general_content_width_type', function (setting) {
        let visibility = function(){
            let arr = {
                osf_layout_general_content_width_px: {
                    value: 'px',
                    equal: '='
                },
                osf_layout_general_content_width_percent: {
                    value: '%',
                    equal: '='
                },
            };
            let value = '' + setting.get();
            for(let id in arr){
                $('#customize-control-' + id).hide();
                if(arr[id].equal === '!='){
                    if(arr[id].value !== value){
                        $('#customize-control-' + id).show();
                    }
                }else{
                   if(arr[id].value === value){
                        $('#customize-control-' + id).show();
                    }             
                }
            }
        }
        visibility();
        setting.bind(visibility);
    });
    wp.customize('osf_page_404_page_enable', function (setting) {
        let visibility = function(){
            let arr = {
                osf_page_404_bg_image: {
                    value: 'default',
                    equal: '='
                },
                osf_page_404_bg_position: {
                    value: 'default',
                    equal: '='
                },
                osf_page_404_bg_repeat: {
                    value: 'default',
                    equal: '='
                },
                osf_page_404_bg: {
                    value: 'default',
                    equal: '='
                },
                osf_page_404_page_custom: {
                    value: 'custom',
                    equal: '='
                },
            };
            let value = '' + setting.get();
            for(let id in arr){
                $('#customize-control-' + id).hide();
                if(arr[id].equal === '!='){
                    if(arr[id].value !== value){
                        $('#customize-control-' + id).show();
                    }
                }else{
                   if(arr[id].value === value){
                        $('#customize-control-' + id).show();
                    }             
                }
            }
        }
        visibility();
        setting.bind(visibility);
    });
    wp.customize('osf_header_enable_builder', function (setting) {
        let visibility = function(){
            let arr = {
                osf_header_builder: {
                    value: 'true',
                    equal: '='
                },
                osf_header_width: {
                    value: 'true',
                    equal: '!='
                },
            };
            let value = '' + setting.get();
            for(let id in arr){
                $('#customize-control-' + id).hide();
                if(arr[id].equal === '!='){
                    if(arr[id].value !== value){
                        $('#customize-control-' + id).show();
                    }
                }else{
                   if(arr[id].value === value){
                        $('#customize-control-' + id).show();
                    }             
                }
            }
        }
        visibility();
        setting.bind(visibility);
    });
    wp.customize('osf_footer_layout', function (setting) {
        let visibility = function(){
            let arr = {
                osf_footer_copyright: {
                    value: '0',
                    equal: '='
                },
            };
            let value = '' + setting.get();
            for(let id in arr){
                $('#customize-control-' + id).hide();
                if(arr[id].equal === '!='){
                    if(arr[id].value !== value){
                        $('#customize-control-' + id).show();
                    }
                }else{
                   if(arr[id].value === value){
                        $('#customize-control-' + id).show();
                    }             
                }
            }
        }
        visibility();
        setting.bind(visibility);
    });
});